/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProductSwiper_item = {
    readonly carouselPhotos: ReadonlyArray<{
        readonly " $fragmentRefs": FragmentRefs<"ThumbImage_photo">;
    } | null> | null;
    readonly " $refType": "ProductSwiper_item";
};
export type ProductSwiper_item$data = ProductSwiper_item;
export type ProductSwiper_item$key = {
    readonly " $data"?: ProductSwiper_item$data;
    readonly " $fragmentRefs": FragmentRefs<"ProductSwiper_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": 3,
      "kind": "LocalArgument",
      "name": "photosLimit"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductSwiper_item",
  "selections": [
    {
      "alias": "carouselPhotos",
      "args": [
        {
          "kind": "Variable",
          "name": "limit",
          "variableName": "photosLimit"
        }
      ],
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ThumbImage_photo"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '68406aa4b45fd58003630d3d8541f235';
export default node;
